<!-- For Ads -->
<ng-container *ngIf="ads; else default">
  <div class="my-card" style="background-color: rgba(var(--secondary-r), var(--secondary-g), var(--secondary-b), 0.75)">
    <div class="image">
      <a [href]="'https://' + list?.url" target="_blank" rel="noopener noreferrer"><img loading="lazy" [src]="imgUrl + list.image" class="img-pro" /></a>
    </div>
    <div class="detail">
      <div>
        <div class="detail_title" style="color: white">{{ list.description.substr(0, 60) }}<span *ngIf="list.description.length > 60">...</span></div>

        <small *ngIf="list.unit != 'null' && list.unit != 0" style="position: absolute; bottom: 0">{{ list.unit != "Nil" ? list.unit : "" }}</small>
      </div>

      <div class="bar">
        <div class="price" style="color: white"><span>$</span>{{ list.price }}</div>
      </div>
      <div class="tag"><span>Ads</span></div>
    </div>
  </div>
</ng-container>
<!-- For Ads -->

<!-- For Product -->
<ng-template #default>
  @if(viewDesign === 'grid') {
  <div style="height: 100%" placement="bottom" ngbTooltip="{{ followRecommendedBy + followLikes }}">
    <div
      class="my-card"
      [ngClass]="{
        'animated-card': (list.isHighlight && withHighlight) || list.isOnlineStatus || (list.glowPoints > 0 && list.glowType == 1),
        'glow-purple': list.glowPoints > 0 && list.glowType == 2,
        'bg-purple': list?.isAd,
        'bg-transparent': list?.isTypeShop
      }"
    >
      <div *ngIf="list?.isTypeShop" class="d-flex align-items-center mb-2">
        <!-- <img class="shadow" [src]="!list?.appUser?.profileCharacterImageFile ? '../../../../../assets/images/w.jpeg' :  imgUrl + list?.appUser?.profileCharacterImageFile" style="width: 1.5rem; height: 1.5rem; border-radius: 50%;"/> -->
        <div class="d-flex flex-column align-items-center justify-content-center ml-3" style="font-size: 0.9rem">
          <!-- <span class="ml-2">
            {{list?.appUser?.profileCharacterName}}
          </span> -->
          <span> <i class="fas fa-bolt"></i> {{ commonService.timeAgo(list?.updated) }}</span>
        </div>
      </div>
      <!-- <span *ngIf="!list?.hasBeenSurvey24Hr && isSameSubRegion" class="position-absolute" style="right: 0.2rem; top: 0.2rem"><img src="../../../../../assets/images/gold-coin.png" class="gold-coin" /></span> -->

      <div *ngIf="!list?.hasBeenSurvey24Hr && isSameSubRegion" class="gold-image-coin">
        <img src="/assets/images/star-coin.png" />
        <img class="shine" src="/assets/images/shine.webp" />
      </div>
      <div *ngIf="isAdmin" class="additional-tag flip-card" (mouseenter)="showMiddleContact = true" (mouseleave)="showMiddleContact = false" (click)="!isAdmin && additionalTag == 'youtube' ? openYoutubeIframes() : openEditVerifiedTag()">
        <div *ngIf="isAdmin" class="item">
          <i class="fa-solid fa-gear"></i>
        </div>

        <div class="item" *ngFor="let tag of getTags(list?.additionalTag)">
          <ng-container [ngSwitch]="tag">
            <i *ngSwitchCase="'Human Icon'" class="fa-solid fa-person"></i>

            <i *ngSwitchCase="'Star'" class="fa-regular fa-star"></i>

            <div *ngSwitchCase="'Youtube'" class="flip-card-inner animation">
              <div class="flip-card-front">
                <i class="fa-brands fa-youtube"></i>
              </div>
              <div class="flip-card-back">
                <i class="fa-solid fa-person"></i>
              </div>
            </div>

            <i *ngSwitchCase="'Affordable'" class="fa-solid fa-dollar-sign"></i>

            <i *ngSwitchCase="'Hidden Gem'" class="fa-solid fa-gem"></i>

            <i *ngSwitchCase="'Must Try'" class="fa-solid fa-crown"></i>
          </ng-container>
        </div>

        <!-- <div *ngIf="list?.additionalTag" class="item">
          @if(list?.additionalTag == 'Human Icon') {
          <i class="fa-solid fa-person"></i>
          } @else if(list?.additionalTag == ',Star'){
          <i class="fa-regular fa-star"></i>
          }@else if(list?.additionalTag == 'Youtube'){
          <div class="flip-card-inner animation">
            <div class="flip-card-front">
              <i class="fa-brands fa-youtube"></i>
            </div>
            <div class="flip-card-back">
              <i class="fa-solid fa-person"></i>
            </div>
          </div>
          } @else if(list?.additionalTag == 'Affordable'){
          <i class="fa-solid fa-dollar-sign"></i>
          }@else if(list?.additionalTag == 'Hidden Gem'){
          <i class="fa-solid fa-gem"></i>
          }@else if(list?.additionalTag == 'Must Try') {
          <i class="fa-solid fa-crown"></i>
          }
        </div> -->
      </div>

      <div *ngIf="!filterMapsIcon?.length" class="position-absolute d-flex flex-column" style="right: 0.75em; top: 0.75em; z-index: 10">
        <input *ngIf="canBeSelected" style="accent-color: var(--secondary)" type="checkbox" [(ngModel)]="isSelected" (change)="selectedChanged()" />
        <div *ngIf="list?.productMoreServices && list?.productMoreServices?.length" [class.mb-2]="canBeSelected">
          <img ngSrc="assets/images/promo.webp" width="58" height="20" alt="Promotion icon" />
        </div>
      </div>

      <div *ngIf="filterMapsIcon?.length" class="promotion-badge">
        <span *ngFor="let filter of filterMapsIcon">
          @if(filter.value == 'affordable' && list?.forum){
          <i [class]="filter.icon"></i>
          } @if(filter.value == 'promotion' && list?.productMoreServices?.length){
          <!-- <i [class]="filter.icon"></i> -->
          <img ngSrc="assets/images/promo.webp" width="58" height="20" alt="Promotion icon" />

          } @if(filter.value == 'available'){
          <i [class]="filter.icon"></i>
          }
        </span>
      </div>

      <div style="position: absolute; left: 0.75em; top: 0.75em; z-index: 200; color: var(--secondary); background: rgba(255, 255, 255, 0.5); backdrop-filter: blur(2px); border-radius: 0.25em; width: 2em; height: 2em; display: flex; align-items: center; justify-content: center" *ngIf="categoryImage" class="shadow-sm p-2">
        <img [src]="imgUrl + categoryImage" style="filter: var(--primary-filter); height: 1.1em; width: auto" />
      </div>
      <div class="report_status" *ngIf="list.reportCount > 0 && roleService?.roles?.userType?.includes('ADMIN')">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      </div>
      <div class="online_status" *ngIf="list.isShopOwnerOnline">
        <i class="fa fa-circle" aria-hidden="true"></i>
      </div>
      <div class="image">
        <div class="middle-contact" *ngIf="isAdmin && list?.shoutContact && list?.shoutContact != 'null' && list?.shoutContact != '65null' && !showMiddleContact">
          {{ list?.shoutContact }}
        </div>
        <div class="middle-contact" *ngIf="showMiddleContact">
          {{ list?.linked && list?.additionalTag != "Youtube" ? list?.linked : ("" | titlecase) }}
        </div>
        <div class="rating-flip-container" *ngIf="isVerified || googleRating">
          <div class="verified-tag" [class.flip-item]="isVerified && googleRating" *ngIf="isVerified" [class.verified-blue]="list.verifiedTag?.trim()?.toLowerCase() == 'chain'">
            @if(list.type=='promote'){
            {{ productTag | titlecase }}
            }@else{ HomeBased }

            <div class="rhoumbus-outer" *ngIf="!specialTags.has(list.verifiedTag?.trim()) && list?.type == 'promote'" ngbTooltip="{{ ((verifiedTagRating / 3) * 100)?.toFixed(1) }} %">
              <div class="rhoumbus-inner" [style.width.%]="(verifiedTagRating / 3) * 100"></div>
            </div>
          </div>
          <div class="google-rating" [class.flip-item]="googleRating && isVerified" *ngIf="googleRating">
            <span>{{ googleRating.rating | number : "1.1-1" }} <i class="fa-solid fa-star star-icon"></i> ({{ googleRating.count }})</span>
          </div>
        </div>
        <!-- <div class="verified" [class.verified-special-red]="list.verifiedTag?.trim() == 'Top Seller'" [class.verified-special]="list.verifiedTag?.trim() == 'Preferred'" *ngIf="isVerified || list.type != 'promote'">
            @if(list.type=='promote'){
            {{ (list.verifiedTag?.trim()?.length ? list.verifiedTag : "Verified").toLowerCase() | titlecase }}
            <div class="rhoumbus-outer" *ngIf="!specialTags.has(list.verifiedTag?.trim())">
              <div class="rhoumbus-inner" [style.width.%]="(verifiedTagRating / 3) * 100"></div>
            </div>
  
            }@else{ HomeBased }
          </div> -->

        <ng-template #withinRadius>
          <span class="region" *ngIf="!list?.isTypeShop" placement="top" ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}"> {{ "\< " + (list?.distance ?? " 5km") }} </span>
        </ng-template>

        <div class="product-distance" *ngIf="list.isWithinRadius"><i class="fa-solid fa-location"></i> {{ list.distance }}</div>

        <!-- - <div class="product-points" style="position: absolute; bottom: 0; left: 0; z-index: 2;" *ngIf="list?.sellerInfo?.superDealRating  || list?.sellerInfo?.superDealText
        ">
          <span> 
            <img src="../../../../../assets/images/super_deal.png" ngbTooltip="Super Deal" style="width: 2rem; aspect-ratio: 1/1;" />
          </span>
        </div> -->

        <!-- <div class="product-points" style="position: absolute; bottom: 0; left: 0" *ngIf="list.xpCount">
          <span class="badge badge-info" style="background-color: var(--primary)"> <i class="fa-solid fa-medal"></i> {{ list.xpCount }} </span>
        </div> -->

        <!-- if('highQualityRating' in sellerInfo){
          this.otherRatingBadges.push({
            icon: 'high_quality.png',
            name: 'Hight Quality',
            rating: sellerInfo.highQualityRating,
            text: sellerInfo.highQualityText
          }
        } -->

        @if(list.isDeleted){

        <img loading="lazy" src="../../assets/images/shop/deleted.jpg" [class.radius-left]="list.user_detail?.id" class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" />
        }@else{
        <!-- <ng-container *ngIf="isBrowser">
            @if(isThereValidCropInformation){ -->
        @if(noCrop){
        <img class="img-pro" [src]="imgUrl + list.indexImage" />
        }@else{
        <app-cropped-image [imgSrc]="imgUrl + list.indexImage" [cropInformation]="list?.mainImageCropInformation" [imgAlt]="'Image ' + list.name" (click)="viewProductDetails(list)" [isReported]="list?.isReported"></app-cropped-image>

        }
        <!-- }@else{
                <img loading="lazy" [src]="imgUrl + list.indexImage" [class.radius-left]="list.user_detail?.id" 
                class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" /> 
  
            }
          </ng-container> -->
        }

        <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" class="shop-img" (click)="goToBiz(list)">
          <img loading="lazy" [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
        </div>
        <span *ngIf="isAdmin && !list?.isTypeShop" placement="bottom" ngbTooltip="The information in this product is {{ infoCount }}/10 click to add click to add more info and get rewarded" style="position: absolute; top: 1.75rem; left: 0.2rem" class="badge badge-info info-badge" [class.plain-black]="list?.type == 'promote' && !isVerified" (click)="openContribute()"> {{ infoCount }}/10 </span>
      </div>
      <div class="custom-tag-container" *ngIf="!list?.isTypeShop">
        <!-- <ng-container *ngIf="list?.additionalTag === 'Must Try'">
          <div class="tag-circle text-primary" (click)="favoriteProduct(list)">
            <i class="fa-crown" [class.fa-solid]="list?.isFavorite" [class.fa]="!list?.isFavorite" ngbTooltip="{{ ['Hidden Gem'].includes(list?.additionalTag) ? list?.linked : followLikes }}" placement="top"> </i>
          </div>
        </ng-container> -->

        @if(isLogin) {
        <div class="flip-card">
          <div class="tag-circle">
            <div class="flip-card-inner" [class.animation]="list?.additionalTag">
              <div class="flip-card-front">
                @if(list?.additionalTag) {
                <div class="text-primary tag-rotate-icons" [style.--icons-count]="getTags(list?.additionalTag).length" (click)="!isAdmin && list?.additionalTag === 'Youtube' ? openYoutubeIframes() : openEditVerifiedTag()" ngbTooltip="{{ list?.linked && list?.additionalTag !== 'Youtube' ? list?.linked : ('' | titlecase) }}">
                  <ng-container *ngFor="let tag of getTags(list?.additionalTag)">
                    <ng-container [ngSwitch]="tag">
                      <i *ngSwitchCase="'Human Icon'" class="fa-solid fa-person"></i>
                      <i *ngSwitchCase="'Star'" class="fa-regular fa-star"></i>
                      <i *ngSwitchCase="'Youtube'" class="fa-brands fa-youtube"></i>
                      <i *ngSwitchCase="'Affordable'" class="fa-solid fa-dollar-sign"></i>
                      <i *ngSwitchCase="'Hidden Gem'" class="fa-solid fa-gem"></i>
                      <i *ngSwitchCase="'Must Try'" class="fa-solid fa-crown"></i>
                    </ng-container>
                  </ng-container>
                </div>
                } @else {
                <div (click)="favoriteProduct(list)" class="text-danger">
                  <i [class.fa-solid]="list?.isFavorite" [class.fa-regular]="!list?.isFavorite" class="fa-heart" ngbTooltip="{{ followLikes }}" placement="top"> </i>
                </div>
                }
              </div>

              <div class="flip-card-back">
                <div (click)="favoriteProduct(list)" class="text-danger">
                  <i [class.fa-solid]="list?.isFavorite" [class.fa-regular]="!list?.isFavorite" class="fa-heart" ngbTooltip="{{ followLikes }}" placement="top"> </i>
                </div>
              </div>
            </div>
          </div>
        </div>
        } @else {
        <div class="tag-circle" *ngIf="list?.additionalTag">
          <div class="text-primary tag-rotate-icons" [style.--icons-count]="getTags(list?.additionalTag).length" (click)="!isAdmin && list?.additionalTag === 'Youtube' ? openYoutubeIframes() : openEditVerifiedTag()" ngbTooltip="{{ list?.linked && list?.additionalTag !== 'Youtube' ? list?.linked : ('' | titlecase) }}">
            <ng-container *ngFor="let tag of getTags(list?.additionalTag)">
              <ng-container [ngSwitch]="tag">
                <i *ngSwitchCase="'Human Icon'" class="fa-solid fa-person"></i>
                <i *ngSwitchCase="'Star'" class="fa-regular fa-star"></i>
                <i *ngSwitchCase="'Youtube'" class="fa-brands fa-youtube"></i>
                <i *ngSwitchCase="'Affordable'" class="fa-solid fa-dollar-sign"></i>
                <i *ngSwitchCase="'Hidden Gem'" class="fa-solid fa-gem"></i>
                <i *ngSwitchCase="'Must Try'" class="fa-solid fa-crown"></i>
              </ng-container>
            </ng-container>
          </div>
        </div>
        }

        <!-- Default empty div if no tag -->
        <div *ngIf="!isLogin && !list?.additionalTag"></div>

        <!-- Region Section -->
        <ng-container *ngIf="!list?.isAd">
          <span *ngIf="!list?.isWithinRadius && !list?.isTypeShop; else withinRadius" class="region" placement="top" ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}" (click)="onLocationButtonClicked()">
            <div class="glow-crown" *ngIf="list?.hasCrown">
              <i class="fa fa-crown"></i>
            </div>

            <button *ngIf="showLocationIconNextToRegion" class="t-btn mr-2 text-white">
              <i class="fa-solid fa-location-dot"></i>
            </button>

            <div>
              {{ (list?.subRegionName?.split(",").includes("all") ? "Doorstep" : regionSplit(list?.subRegionName)) | titlecase }}
            </div>
          </span>
        </ng-container>
      </div>

      <!-- <div class ='verified-row'>
        <span *ngIf="isVerified" class ='verified'>{{ (list.verifiedTag ?? "Verified") | titlecase }}</span>
      </div> -->

      <div class="detail mt-1">
        <div class="detail_title" (click)="viewProductDetails(list)">
          @if(list?.companyName?.trim() && list?.companyName?.toLowerCase()?.trim() != 'null'){
          <div class="company-name">
            {{ list.companyName }}
          </div>
          }

          <div class="short">{{ list.name }}</div>
          {{ list.isDeleted ? " (DELETED)" : "" }}
        </div>

        <div class="bar">
          @if(list?.foodSpecs && !isCommunityProduct){
          <div class="price" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'"><span>$</span>{{ list?.foodSpecs[0]?.key }}</div>
          }@else{
          <ng-container *ngIf="list?.memberShopProductsVariations">
            <div class="price">
              <span *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
              {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : list?.type != "promote" ? "FREE" : "" }}
            </div>
          </ng-container>
          }
          <span class="favorite">
            @if(!(!isLogin || !list?.foodFavoritesCount) && !isUpvote && !list?.isTypeShop){
            <span class="number">{{ list?.foodFavoritesCount ? list?.foodFavoritesCount : "" }}</span>
            <i (click)="favoriteProduct(list)" [class.fa-solid]="list?.isFavorite" [class.fa-regular]="!list?.isFavorite" [class.fa-heart]="list?.additionalTag != 'Hidden Gem'" [class.fa-gem]="list?.additionalTag == 'Hidden Gem'" ngbTooltip="{{ ['Hidden Gem'].includes(list?.additionalTag) ? list?.linked : followLikes }}" placement="top"> </i>

            }
            <!-- <div class="d-flex" style="gap: 0.2rem" *ngIf="isUpvote">
              <span class="vote-buttons">
                <button [class.active]="list?.isFavorite" (click)="favoriteProduct(list)" [disabled]="!isLogin">
                  <i class="fa fa-thumbs-up" [ngClass]="list?.isFavorite ? 'fa-solid' : 'fa-regular'"></i>
                  <span class="text">
                    {{ list?.isFavorite ? 'Upvoted' : 'Upvote' }}
                  </span>
                </button>
              </span>
              <button class="comment-icon" ngbTooltip="Comment" placement="top" (click)="onComment(list)"
                [disabled]="!isLogin">
                <i class="fa fa-comment"></i>
              </button>
            </div> -->
          </span>
        </div>
        <div class="w-100 d-flex justify-content-between align-items-center" [class.mt-2]="isUpvote" style="margin-top: 0.4em; height: 0.75em">
          <small style="font-size: 0.75em">
            {{ list.unit != "null" && list.unit != 0 && list?.memberShopProductsVariations?.length && list?.memberShopProductsVariations[0]?.key > 0 ? list.unit : "" }}
          </small>

          <span class="d-flex align-items-center" style="min-width: fit-content" *ngIf="isMemberProduct && !list?.isTypeShop">
            <small class="mr-1">{{ viewCount }}</small>
            <small class="">Views</small>
          </span>
          <!-- <div class="d-flex w-100 align-items-center" *ngIf="list?.isTypeShop">
            <i (click)="favoriteProduct(list)" 
              [class.fa-solid]="list?.isFavorite"
              [class.fa-regular]="!list?.isFavorite"
              class="fa-heart mr-2"> </i>
             
            </div> -->
        </div>

        <div class="tag" *ngIf="list?.type && !list?.isTypeShop">
          <div>
            @if(list?.dollarSignRating && (list?.dollarSignRating / 3) * 100 < 50) {
            <svg width="20" viewBox="0 0 338 385" fill="none">
              <path d="M25.9999 384.3C5.09988 371.9 0.299882 353.3 0.599882 329.9C1.69988 257.9 1.29988 185.9 0.799879 114C0.699879 96 6.29988 82.6 20.9999 71.7C44.6999 54.1 66.8999 34.7 90.5999 17.1C99.8999 10.2 111.4 6.09995 121.8 0.699951C112.7 22.9 103.6 45 94.4999 67.2C76.9999 56.6 68.6999 59.8 64.1999 79C52.9999 82.1 43.1999 86.9 46.3999 101.1C48.7999 111.4 61.3999 116.7 74.4999 113.7C77.2999 113 79.9999 111.6 82.7999 110.6C82.8999 117 83.0999 123.3 83.1999 129.7L83.3999 130.7C47.1999 130.6 40.4999 137.2 40.4999 172.7C40.4999 219 40.3999 265.4 40.5999 311.7C40.6999 330.1 50.4999 341.4 68.5999 341.8C95.4999 342.4 122.3 341.4 149.2 341.1C151.1 341.6 153 342 154.9 342.5C168.9 356.5 182.9 370.4 197 384.4C140 384.3 82.9999 384.3 25.9999 384.3Z" fill="var(--primary)" />
              <path d="M287.5 360.4C279.3 368.4 271.2 376.3 263 384.3C255 384.3 247 384.3 239 384.3C237.6 380.4 237.4 375.3 234.7 372.6C223.3 361.1 211.1 350.2 199.2 339.2C191.8 331.9 183.9 325.1 177.4 317C174.5 313.3 172.5 306.4 174 302.5C175.5 298.7 181.8 295.5 186.5 294.6C193 293.3 200.1 294.3 206.1 294.3C207.3 291.9 208.1 291 208.1 290.1C208.3 261.8 207.7 233.5 208.9 205.3C209.2 197.2 214.5 189.4 217.5 181.4C230.3 180.4 243.2 179.4 256 178.4C260.4 178.9 264.7 179.4 269.1 179.9C253.9 213.2 242.9 247 250.7 284.5C256.8 313 266 339.6 287.5 360.4Z" fill="#2BCD69" />
              <path d="M199.3 339.3C211.2 350.4 223.3 361.2 234.8 372.7C237.5 375.4 237.7 380.4 239.1 384.4C225.1 384.4 211.1 384.4 197.1 384.4C183.1 370.4 169.1 356.5 155 342.5C169.7 341.4 184.5 340.3 199.3 339.3Z" fill="var(--primary)" />
              <path d="M256.2 178.4C243.4 179.4 230.5 180.4 217.7 181.4C217.6 179.4 217.6 177.4 217.5 175.4C217.2 138.8 208.1 129.8 171.3 129.8C141.9 129.8 112.6 129.7 83.1998 129.7C83.0998 123.3 82.8998 117 82.7998 110.6C92.2998 102.6 88.9998 93.2 85.6998 83.7C100.3 84.4 97.3998 75.8 94.4998 67.1C103.6 44.9 112.7 22.8 121.8 0.599986C138.3 -1.50001 151.9 4.99998 164.4 15C188.9 34.6 213.3 54.4 238.1 73.6C251.1 83.7 256.3 96.7 256.2 112.6C256.3 134.6 256.3 156.5 256.2 178.4ZM180.9 80.1C172.1 83.9 163.6 90.1 167.8 100C170.4 106.2 179.1 112 186.2 113.8C197.4 116.7 208 111.2 210.4 99.7C213.1 86.9 202.8 81.8 192 78.9C191.2 68.8 186.2 61.1 175.9 61.5C170.8 61.7 165.5 67.3 161.4 71.5C160 72.9 162 77.7 162.5 80.9C165.2 79.7 169 79.4 170.5 77.3C176.7 69.2 178.8 74 180.9 80.1ZM110 43.4C118.5 49.6 123.8 56.3 127.5 55.5C132.5 54.4 138.7 47.9 139.7 42.9C140.3 39.6 132.7 31.4 128.6 31.3C123.7 31.1 118.7 37.3 110 43.4ZM128 101.6C130.6 100.9 132.5 101 133.4 100.1C137.3 96.3 140.8 92.3 144.5 88.3C140.2 88 135.9 87.9 131.7 87.4C127.9 86.9 124.1 85.7 120.3 85.5C117.7 85.4 115.1 86.6 112.4 87.3C113.3 90.3 113.4 94.5 115.4 96C119.3 98.8 124.3 100.1 128 101.6Z" fill="var(--primary)" />
              <path d="M287.5 360.4C266 339.6 256.8 312.9 250.9 284.4C243.1 246.9 254.2 213.1 269.3 179.8C299.9 179.2 302.6 181.8 302.6 212.7C302.6 239.1 302.6 265.4 302.6 294.2C310.4 294.2 317.3 293.3 323.8 294.5C328.6 295.4 335.6 298.2 336.8 301.8C338.3 306.3 336.7 314.2 333.3 317.6C318.6 332.5 302.9 346.3 287.5 360.4Z" fill="#73D98C" />
              <path d="M83.2994 129.7C112.699 129.7 141.999 129.8 171.399 129.8C208.099 129.8 217.199 138.8 217.599 175.4C217.599 177.4 217.699 179.4 217.799 181.4C214.799 189.4 209.499 197.2 209.199 205.3C207.999 233.5 208.599 261.9 208.399 290.1C208.399 291 207.599 291.8 206.399 294.3C200.399 294.3 193.299 293.3 186.799 294.6C182.099 295.6 175.799 298.7 174.299 302.5C172.699 306.4 174.799 313.4 177.699 317C184.099 325.1 192.099 331.9 199.499 339.2C184.699 340.3 169.999 341.3 155.199 342.4C153.299 341.9 151.399 341.5 149.499 341C141.399 328.3 133.399 315.5 125.299 302.8C135.299 292.9 146.599 284.1 154.799 272.9C164.599 259.6 162.099 242.4 147.899 235.2C128.499 225.4 134.499 211.1 135.299 196.4C141.399 197.1 146.299 197.6 151.299 198.1C151.999 196.6 152.699 195 153.399 193.5C149.199 190.3 144.599 187.4 140.799 183.8C136.299 179.5 132.399 174.4 128.199 169.7C123.799 174.9 120.299 181.4 114.799 185.1C95.3994 198.7 95.3994 218.1 115.099 232.2C118.499 234.6 121.299 239.6 121.899 243.7C122.999 251 121.799 258.7 122.299 266.1C122.999 275.6 118.299 277.3 110.399 275.3C107.099 268.1 103.399 261.1 100.499 253.8C84.7994 214.1 80.5994 172.8 83.6994 130.5L83.2994 129.7Z" fill="#F7EC7F" />
              <path d="M83.5002 130.7C80.4002 173 84.7002 214.3 100.3 254C103.2 261.3 106.9 268.4 110.2 275.5C100.6 281.7 110.8 284.4 112.9 287.7C116.2 293.2 121 297.8 125.1 302.8C133.2 315.5 141.2 328.3 149.3 341C122.4 341.3 95.5002 342.3 68.7002 341.7C50.6002 341.3 40.8002 330.1 40.7002 311.6C40.5002 265.3 40.6002 218.9 40.6002 172.6C40.6002 137.2 47.3002 130.6 83.5002 130.7Z" fill="#F8CE71" />
              <path d="M85.7998 83.8C78.5998 82.2 71.4998 80.6 64.2998 79C68.7998 59.8 77.0998 56.6 94.5998 67.2C97.4998 75.8 100.4 84.4 85.7998 83.8Z" fill="#fff" />
              <path d="M192.1 78.9C188.4 79.3 184.7 79.7 180.9 80.1C178.8 74 176.7 69.2 170.5 77.4C168.9 79.4 165.2 79.8 162.5 81C162 77.8 160 73 161.4 71.6C165.5 67.4 170.9 61.8 175.9 61.6C186.3 61.1 191.2 68.8 192.1 78.9Z" fill="#fff" />
              <path d="M128 101.6C124.3 100.1 119.3 98.8 115.5 96C113.5 94.5 113.4 90.3 112.5 87.3C115.1 86.7 117.8 85.4 120.4 85.5C124.2 85.6 127.9 86.9 131.8 87.4C136.1 87.9 140.4 88 144.6 88.3C140.9 92.3 137.4 96.3 133.5 100.1C132.5 101 130.6 100.9 128 101.6Z" fill="#fff" />
              <path d="M125.1 302.8C121 297.8 116.2 293.2 112.9 287.7C110.8 284.3 100.6 281.7 110.2 275.5C118.1 277.5 122.8 275.8 122.1 266.3C121.6 258.8 122.8 251.2 121.7 243.9C121.1 239.7 118.3 234.8 114.9 232.4C95.1996 218.4 95.1996 198.9 114.6 185.3C120 181.5 123.6 175.1 128 169.9C132.2 174.6 136.1 179.6 140.6 184C144.4 187.6 149 190.5 153.2 193.7C152.5 195.2 151.8 196.8 151.1 198.3C146.1 197.8 141.2 197.2 135.1 196.6C134.3 211.2 128.4 225.6 147.7 235.4C161.9 242.6 164.5 259.8 154.6 273.1C146.4 284.1 135 293 125.1 302.8ZM134.4 273.8C135.9 274.5 137.5 275.1 139 275.8C142.1 269.2 147.4 262.6 147.6 255.9C147.8 251 141.2 245.9 137.7 240.9C136.6 241.6 135.5 242.2 134.4 242.9C134.4 253.1 134.4 263.5 134.4 273.8ZM121.2 194.5C107 208.1 107.4 213.1 121.2 220.2C121.2 212.3 121.2 204.7 121.2 194.5Z" fill="#FE757F" />
              <path d="M134.399 273.8C134.399 263.5 134.399 253.2 134.399 242.9C135.499 242.2 136.599 241.6 137.699 240.9C141.299 245.9 147.799 251 147.599 255.9C147.399 262.6 142.099 269.2 138.999 275.8C137.499 275.1 135.899 274.4 134.399 273.8Z" fill="#F8E680" />
              <path d="M121.2 194.5C121.2 204.7 121.2 212.3 121.2 220.2C107.4 213.1 107 208.1 121.2 194.5Z" fill="#F9DF7F" />
            </svg>
            }

            <!-- <img style="width: 20px" src="../../../../../assets/images/price-tag.png" alt="" /> -->
            <!-- <span placement="top" style="z-index: 2;" class="shout-out">
              <img [src]="'../../../../../assets/images/' + otherRatingBadges[0].icon" *ngIf="otherRatingBadges.length"
                [ngbTooltip]="otherRatingBadges[0].name" style="height: 2rem;" />
            </span> -->
            <!-- <div class="dollar-sign-outer" [ngStyle]="{ visibility: list?.dollarSignRating ? 'visible' : 'hidden' }">
              <div class="dollar-sign-inner" [style.width.%]="(list?.dollarSignRating / 3) * 100"></div>
            </div> -->
          </div>

          <div class="short-tag">
            {{ list.categoryName }}
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group vote-section" *ngIf="isUpvote">
      <button class="w-100 vote-button" [class.active]="list?.isFavorite" (click)="favoriteProduct(list)" [disabled]="!isLogin">
        <i class="fa fa-thumbs-up" [ngClass]="list?.isFavorite ? 'fa-solid' : 'fa-regular'"></i>
        <span class="text">
          {{ list?.isFavorite ? "Upvoted" : "Upvote" }}
        </span>
      </button>
      <button class="w-100 vote-button comment-button" (click)="openDiscuss(list)" [disabled]="!isLogin">
        <i class="fa fa-comment"></i>
        <span class="text"> Discuss </span>
      </button>
    </div>
  </div>
  } @if(viewDesign === 'column') {
  <div placement="bottom" ngbTooltip="{{ followRecommendedBy + followLikes }}">
    <div
      class="my-card-column"
      [ngClass]="{
        'animated-card': (list.isHighlight && withHighlight) || list.isOnlineStatus || (list.glowPoints > 0 && list.glowType == 1),
        'glow-purple': list.glowPoints > 0 && list.glowType == 2
      }"
    >
      <div class="image">
        <div class="rating-flip-container" *ngIf="isVerified || googleRating">
          <div class="verified-tag" [class.flip-item]="isVerified && googleRating" [class.verified-blue]="list.verifiedTag?.trim()?.toLowerCase() == 'chain'">
            @if(list.type=='promote'){
            {{ productTag | titlecase }}
            }@else{ HomeBased }

            <div class="rhoumbus-outer" *ngIf="!specialTags.has(list.verifiedTag?.trim()) && list?.type == 'promote'" ngbTooltip="{{ ((verifiedTagRating / 3) * 100)?.toFixed(1) }} %">
              <div class="rhoumbus-inner" [style.width.%]="(verifiedTagRating / 3) * 100"></div>
            </div>
          </div>
          <div class="google-rating" [class.flip-item]="googleRating && isVerified">
            <i class="fa-brands fa-google"></i>
            <span>4.9 <i class="fa-solid fa-star star-icon"></i> (1080)</span>
          </div>
        </div>
        <ng-template #withinRadius>
          <span class="region" *ngIf="!list?.isTypeShop" placement="bottom" ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}"> {{ "\< " + (list?.distance ?? " 5km") }} </span>
        </ng-template>

        <div class="product-distance" *ngIf="list.isWithinRadius"><i class="fa-solid fa-location"></i> {{ list.distance }}</div>

        @if(list.isDeleted){
        <img loading="lazy" src="../../assets/images/shop/deleted.jpg" [class.radius-left]="list.user_detail?.id" class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" />
        }@else{ @if(noCrop){
        <img class="img-pro" [src]="imgUrl + list.indexImage" />
        }@else{
        <app-cropped-image [imgSrc]="imgUrl + list.indexImage" [cropInformation]="list?.mainImageCropInformation" [imgAlt]="'Image ' + list.name" (click)="viewProductDetails(list)" [isReported]="list?.isReported"></app-cropped-image>
        } }
        <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" class="shop-img" (click)="goToBiz(list)">
          <img loading="lazy" [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
        </div>
      </div>
      <div *ngIf="!list?.hasBeenSurvey24Hr && isSameSubRegion" class="gold-image-coin">
        <img src="/assets/images/star-coin.png" />
        <img class="shine" src="/assets/images/shine.webp" />
      </div>
      <div *ngIf="list?.additionalTag || isAdmin" class="additional-tag" (mouseenter)="showMiddleContact = true" (mouseleave)="showMiddleContact = false" (click)="!isAdmin && additionalTag == 'youtube' ? openYoutubeIframes() : openEditVerifiedTag()" ngbTooltip="{{ list?.linked && list?.additionalTag != 'Youtube' ? list?.linked : ('' | titlecase) }}">
        <span *ngIf="list?.additionalTag">
          @if(list?.additionalTag == 'Human Icon') {
          <i class="fa-solid fa-person"></i>
          } @else if(list?.additionalTag == ',Star'){
          <i class="fa-regular fa-star"></i>
          }@else if(list?.additionalTag == 'Youtube'){
          <i class="fa-brands fa-youtube"></i>
          }@else if(list?.additionalTag == 'Affordable'){
          <i class="fa-solid fa-dollar-sign"></i>
          }@else if(list?.additionalTag == 'Hidden Gem'){
          <i class="fa-solid fa-gem"></i>
          } @else{
          {{ list?.additionalTag }}
          }
        </span>
        <span *ngIf="isAdmin">
          <i class="fa-solid fa-gear"></i>
        </span>
      </div>
      <div *ngIf="!filterMapsIcon?.length" class="position-absolute d-flex flex-column" style="right: 0.75em; top: 0.75em; z-index: 10">
        <input *ngIf="canBeSelected" style="accent-color: var(--secondary)" type="checkbox" [(ngModel)]="isSelected" (change)="selectedChanged()" />
        <div *ngIf="list?.productMoreServices && list?.productMoreServices?.length" [class.mb-2]="canBeSelected">
          <img ngSrc="assets/images/promo.webp" width="58" height="20" alt="Promotion icon" />
        </div>
      </div>

      <div *ngIf="filterMapsIcon?.length" class="promotion-badge">
        <span *ngFor="let filter of filterMapsIcon">
          @if(filter.value == 'affordable' && list?.forum){
          <i [class]="filter.icon"></i>
          } @if(filter.value == 'promotion' && list?.productMoreServices?.length){
          <img ngSrc="assets/images/promo.webp" width="58" height="20" alt="Promotion icon" />

          } @if(filter.value == 'available'){
          <i [class]="filter.icon"></i>
          }
        </span>
      </div>

      <div style="position: absolute; left: 0.75em; top: 0.75em; z-index: 200; color: var(--secondary); background: rgba(255, 255, 255, 0.5); backdrop-filter: blur(2px); border-radius: 0.25em; width: 2em; height: 2em; display: flex; align-items: center; justify-content: center" *ngIf="categoryImage" class="shadow-sm p-2">
        <img [src]="imgUrl + categoryImage" style="filter: var(--primary-filter); height: 1.1em; width: auto" />
      </div>
      <div class="report_status" *ngIf="list.reportCount > 0 && roleService?.roles?.userType?.includes('ADMIN')">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      </div>
      <div class="online_status" *ngIf="list.isShopOwnerOnline">
        <i class="fa fa-circle" aria-hidden="true"></i>
      </div>

      <div class="detail">
        <div class="detail_title" (click)="viewProductDetails(list)">
          @if(list?.companyName?.trim() && list?.companyName?.toLowerCase()?.trim() != 'null'){
          <div class="company-name">
            {{ list.companyName }}
          </div>
          }

          <div class="short">{{ list.name }}</div>
          {{ list.isDeleted ? " (DELETED)" : "" }}
        </div>

        <div class="bar">
          @if(list?.foodSpecs && !isCommunityProduct){
          <div class="price" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'"><span>$</span>{{ list?.foodSpecs[0]?.key }}</div>
          }@else{
          <ng-container *ngIf="list?.memberShopProductsVariations">
            <div class="price">
              <span *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
              {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : list?.type != "promote" ? "FREE" : "" }}
            </div>
          </ng-container>
          }
          <span class="favorite">
            @if(!(!isLogin || !list?.foodFavoritesCount) && !isUpvote && !list?.isTypeShop){
            <span class="number">{{ list?.foodFavoritesCount ? list?.foodFavoritesCount : "" }}</span>
            <i (click)="favoriteProduct(list)" [class.fa-solid]="list?.isFavorite" [class.fa-regular]="!list?.isFavorite" [class.fa-heart]="list?.additionalTag != 'Hidden Gem'" [class.fa-gem]="list?.additionalTag == 'Hidden Gem'" ngbTooltip="{{ ['Hidden Gem'].includes(list?.additionalTag) ? list?.linked : followLikes }}" placement="top"> </i>

            }
          </span>
        </div>
        <div class="w-100 d-flex justify-content-between align-items-center" [class.mt-2]="isUpvote" style="margin-top: 0.4em; height: 0.75em">
          <small style="font-size: 0.75em">
            {{ list.unit != "null" && list.unit != 0 && list?.memberShopProductsVariations?.length && list?.memberShopProductsVariations[0]?.key > 0 ? list.unit : "" }}
          </small>

          <span class="d-flex align-items-center" style="min-width: fit-content" *ngIf="isMemberProduct && !list?.isTypeShop">
            <small class="mr-1">{{ viewCount }}</small>
            <small class="">Views</small>
          </span>
          <div class="d-flex w-100" *ngIf="list?.isTypeShop">LoVE</div>
        </div>

        <div class="tag" *ngIf="list?.type && !list?.isTypeShop">
          <div>
            @if(list?.dollarSignRating && (list?.dollarSignRating / 3) * 100 < 50) {
            <svg width="20" viewBox="0 0 338 385" fill="none">
              <path d="M25.9999 384.3C5.09988 371.9 0.299882 353.3 0.599882 329.9C1.69988 257.9 1.29988 185.9 0.799879 114C0.699879 96 6.29988 82.6 20.9999 71.7C44.6999 54.1 66.8999 34.7 90.5999 17.1C99.8999 10.2 111.4 6.09995 121.8 0.699951C112.7 22.9 103.6 45 94.4999 67.2C76.9999 56.6 68.6999 59.8 64.1999 79C52.9999 82.1 43.1999 86.9 46.3999 101.1C48.7999 111.4 61.3999 116.7 74.4999 113.7C77.2999 113 79.9999 111.6 82.7999 110.6C82.8999 117 83.0999 123.3 83.1999 129.7L83.3999 130.7C47.1999 130.6 40.4999 137.2 40.4999 172.7C40.4999 219 40.3999 265.4 40.5999 311.7C40.6999 330.1 50.4999 341.4 68.5999 341.8C95.4999 342.4 122.3 341.4 149.2 341.1C151.1 341.6 153 342 154.9 342.5C168.9 356.5 182.9 370.4 197 384.4C140 384.3 82.9999 384.3 25.9999 384.3Z" fill="var(--primary)" />
              <path d="M287.5 360.4C279.3 368.4 271.2 376.3 263 384.3C255 384.3 247 384.3 239 384.3C237.6 380.4 237.4 375.3 234.7 372.6C223.3 361.1 211.1 350.2 199.2 339.2C191.8 331.9 183.9 325.1 177.4 317C174.5 313.3 172.5 306.4 174 302.5C175.5 298.7 181.8 295.5 186.5 294.6C193 293.3 200.1 294.3 206.1 294.3C207.3 291.9 208.1 291 208.1 290.1C208.3 261.8 207.7 233.5 208.9 205.3C209.2 197.2 214.5 189.4 217.5 181.4C230.3 180.4 243.2 179.4 256 178.4C260.4 178.9 264.7 179.4 269.1 179.9C253.9 213.2 242.9 247 250.7 284.5C256.8 313 266 339.6 287.5 360.4Z" fill="#2BCD69" />
              <path d="M199.3 339.3C211.2 350.4 223.3 361.2 234.8 372.7C237.5 375.4 237.7 380.4 239.1 384.4C225.1 384.4 211.1 384.4 197.1 384.4C183.1 370.4 169.1 356.5 155 342.5C169.7 341.4 184.5 340.3 199.3 339.3Z" fill="var(--primary)" />
              <path d="M256.2 178.4C243.4 179.4 230.5 180.4 217.7 181.4C217.6 179.4 217.6 177.4 217.5 175.4C217.2 138.8 208.1 129.8 171.3 129.8C141.9 129.8 112.6 129.7 83.1998 129.7C83.0998 123.3 82.8998 117 82.7998 110.6C92.2998 102.6 88.9998 93.2 85.6998 83.7C100.3 84.4 97.3998 75.8 94.4998 67.1C103.6 44.9 112.7 22.8 121.8 0.599986C138.3 -1.50001 151.9 4.99998 164.4 15C188.9 34.6 213.3 54.4 238.1 73.6C251.1 83.7 256.3 96.7 256.2 112.6C256.3 134.6 256.3 156.5 256.2 178.4ZM180.9 80.1C172.1 83.9 163.6 90.1 167.8 100C170.4 106.2 179.1 112 186.2 113.8C197.4 116.7 208 111.2 210.4 99.7C213.1 86.9 202.8 81.8 192 78.9C191.2 68.8 186.2 61.1 175.9 61.5C170.8 61.7 165.5 67.3 161.4 71.5C160 72.9 162 77.7 162.5 80.9C165.2 79.7 169 79.4 170.5 77.3C176.7 69.2 178.8 74 180.9 80.1ZM110 43.4C118.5 49.6 123.8 56.3 127.5 55.5C132.5 54.4 138.7 47.9 139.7 42.9C140.3 39.6 132.7 31.4 128.6 31.3C123.7 31.1 118.7 37.3 110 43.4ZM128 101.6C130.6 100.9 132.5 101 133.4 100.1C137.3 96.3 140.8 92.3 144.5 88.3C140.2 88 135.9 87.9 131.7 87.4C127.9 86.9 124.1 85.7 120.3 85.5C117.7 85.4 115.1 86.6 112.4 87.3C113.3 90.3 113.4 94.5 115.4 96C119.3 98.8 124.3 100.1 128 101.6Z" fill="var(--primary)" />
              <path d="M287.5 360.4C266 339.6 256.8 312.9 250.9 284.4C243.1 246.9 254.2 213.1 269.3 179.8C299.9 179.2 302.6 181.8 302.6 212.7C302.6 239.1 302.6 265.4 302.6 294.2C310.4 294.2 317.3 293.3 323.8 294.5C328.6 295.4 335.6 298.2 336.8 301.8C338.3 306.3 336.7 314.2 333.3 317.6C318.6 332.5 302.9 346.3 287.5 360.4Z" fill="#73D98C" />
              <path d="M83.2994 129.7C112.699 129.7 141.999 129.8 171.399 129.8C208.099 129.8 217.199 138.8 217.599 175.4C217.599 177.4 217.699 179.4 217.799 181.4C214.799 189.4 209.499 197.2 209.199 205.3C207.999 233.5 208.599 261.9 208.399 290.1C208.399 291 207.599 291.8 206.399 294.3C200.399 294.3 193.299 293.3 186.799 294.6C182.099 295.6 175.799 298.7 174.299 302.5C172.699 306.4 174.799 313.4 177.699 317C184.099 325.1 192.099 331.9 199.499 339.2C184.699 340.3 169.999 341.3 155.199 342.4C153.299 341.9 151.399 341.5 149.499 341C141.399 328.3 133.399 315.5 125.299 302.8C135.299 292.9 146.599 284.1 154.799 272.9C164.599 259.6 162.099 242.4 147.899 235.2C128.499 225.4 134.499 211.1 135.299 196.4C141.399 197.1 146.299 197.6 151.299 198.1C151.999 196.6 152.699 195 153.399 193.5C149.199 190.3 144.599 187.4 140.799 183.8C136.299 179.5 132.399 174.4 128.199 169.7C123.799 174.9 120.299 181.4 114.799 185.1C95.3994 198.7 95.3994 218.1 115.099 232.2C118.499 234.6 121.299 239.6 121.899 243.7C122.999 251 121.799 258.7 122.299 266.1C122.999 275.6 118.299 277.3 110.399 275.3C107.099 268.1 103.399 261.1 100.499 253.8C84.7994 214.1 80.5994 172.8 83.6994 130.5L83.2994 129.7Z" fill="#F7EC7F" />
              <path d="M83.5002 130.7C80.4002 173 84.7002 214.3 100.3 254C103.2 261.3 106.9 268.4 110.2 275.5C100.6 281.7 110.8 284.4 112.9 287.7C116.2 293.2 121 297.8 125.1 302.8C133.2 315.5 141.2 328.3 149.3 341C122.4 341.3 95.5002 342.3 68.7002 341.7C50.6002 341.3 40.8002 330.1 40.7002 311.6C40.5002 265.3 40.6002 218.9 40.6002 172.6C40.6002 137.2 47.3002 130.6 83.5002 130.7Z" fill="#F8CE71" />
              <path d="M85.7998 83.8C78.5998 82.2 71.4998 80.6 64.2998 79C68.7998 59.8 77.0998 56.6 94.5998 67.2C97.4998 75.8 100.4 84.4 85.7998 83.8Z" fill="#fff" />
              <path d="M192.1 78.9C188.4 79.3 184.7 79.7 180.9 80.1C178.8 74 176.7 69.2 170.5 77.4C168.9 79.4 165.2 79.8 162.5 81C162 77.8 160 73 161.4 71.6C165.5 67.4 170.9 61.8 175.9 61.6C186.3 61.1 191.2 68.8 192.1 78.9Z" fill="#fff" />
              <path d="M128 101.6C124.3 100.1 119.3 98.8 115.5 96C113.5 94.5 113.4 90.3 112.5 87.3C115.1 86.7 117.8 85.4 120.4 85.5C124.2 85.6 127.9 86.9 131.8 87.4C136.1 87.9 140.4 88 144.6 88.3C140.9 92.3 137.4 96.3 133.5 100.1C132.5 101 130.6 100.9 128 101.6Z" fill="#fff" />
              <path d="M125.1 302.8C121 297.8 116.2 293.2 112.9 287.7C110.8 284.3 100.6 281.7 110.2 275.5C118.1 277.5 122.8 275.8 122.1 266.3C121.6 258.8 122.8 251.2 121.7 243.9C121.1 239.7 118.3 234.8 114.9 232.4C95.1996 218.4 95.1996 198.9 114.6 185.3C120 181.5 123.6 175.1 128 169.9C132.2 174.6 136.1 179.6 140.6 184C144.4 187.6 149 190.5 153.2 193.7C152.5 195.2 151.8 196.8 151.1 198.3C146.1 197.8 141.2 197.2 135.1 196.6C134.3 211.2 128.4 225.6 147.7 235.4C161.9 242.6 164.5 259.8 154.6 273.1C146.4 284.1 135 293 125.1 302.8ZM134.4 273.8C135.9 274.5 137.5 275.1 139 275.8C142.1 269.2 147.4 262.6 147.6 255.9C147.8 251 141.2 245.9 137.7 240.9C136.6 241.6 135.5 242.2 134.4 242.9C134.4 253.1 134.4 263.5 134.4 273.8ZM121.2 194.5C107 208.1 107.4 213.1 121.2 220.2C121.2 212.3 121.2 204.7 121.2 194.5Z" fill="#FE757F" />
              <path d="M134.399 273.8C134.399 263.5 134.399 253.2 134.399 242.9C135.499 242.2 136.599 241.6 137.699 240.9C141.299 245.9 147.799 251 147.599 255.9C147.399 262.6 142.099 269.2 138.999 275.8C137.499 275.1 135.899 274.4 134.399 273.8Z" fill="#F8E680" />
              <path d="M121.2 194.5C121.2 204.7 121.2 212.3 121.2 220.2C107.4 213.1 107 208.1 121.2 194.5Z" fill="#F9DF7F" />
            </svg>
            }
            <div class="d-flex justify-content-between align-items-center" style="height: 1.4em; overflow: hidden; gap: 0.25em">
              @if(isLogin){
              <div class="product-points">
                <popper-content #contribute>
                  <div></div>
                </popper-content>

                <span placement="top" ngbTooltip="The information in this product is {{ infoCount }}/10 click to add click to add more info and get rewarded" class="badge badge-info info-badge" [class.plain-black]="list?.type == 'promote' && !isVerified" (click)="openContribute()"> {{ infoCount }}/10 </span>
              </div>
              }

              <span *ngIf="!list?.isWithinRadius && list?.isTypeShop; else withinRadius" class="region" placement="top" ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}" (click)="onLocationButtonClicked()">
                <div class="glow-crown" *ngIf="list?.hasCrown">
                  <i class="fa fa-crown"></i>
                </div>
                <button *ngIf="showLocationIconNextToRegion" class="t-btn mr-2" style="color: var(--white)">
                  <i class="fa-solid fa-location-dot"></i>
                </button>
                <div>{{ (list?.subRegionName?.split(",").includes("all") ? "Doorstep" : regionSplit(list?.subRegionName)) | titlecase }}</div>
              </span>
            </div>
          </div>
          <div class="short-tag">
            {{ list.categoryName }}
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group vote-section" *ngIf="isUpvote">
      <button class="w-100 vote-button" [class.active]="list?.isFavorite" (click)="favoriteProduct(list)" [disabled]="!isLogin">
        <i class="fa fa-thumbs-up" [ngClass]="list?.isFavorite ? 'fa-solid' : 'fa-regular'"></i>
        <span class="text">
          {{ list?.isFavorite ? "Upvoted" : "Upvote" }}
        </span>
      </button>
      <button class="w-100 vote-button comment-button" (click)="openDiscuss(list)" [disabled]="!isLogin">
        <i class="fa fa-comment"></i>
        <span class="text"> Discuss </span>
      </button>
    </div>
  </div>
  } @if(viewDesign === 'simple') {
  <div class="card-simple">
    <div class="image">
      @if(list.isDeleted){
      <img loading="lazy" src="../../assets/images/shop/deleted.jpg" [class.radius-left]="list.user_detail?.id" class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" />
      }@else{ @if(noCrop){
      <img class="img-pro" [src]="imgUrl + list.indexImage" />
      }@else{
      <app-cropped-image [imgSrc]="imgUrl + list.indexImage" [cropInformation]="list?.mainImageCropInformation" [imgAlt]="'Image ' + list.name" (click)="viewProductDetails(list)" [isReported]="list?.isReported"></app-cropped-image>
      } }
      <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" class="shop-img" (click)="goToBiz(list)">
        <img loading="lazy" [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
      </div>
    </div>
    <div class="detail mt-1">
      <div class="detail_title" (click)="viewProductDetails(list)">
        @if(list?.companyName?.trim() && list?.companyName?.toLowerCase()?.trim() != 'null'){
        <div class="company-name">
          {{ list.companyName }}
        </div>
        }

        <div class="short">{{ list.name }}</div>
        {{ list.isDeleted ? " (DELETED)" : "" }}
      </div>
    </div>
  </div>
  }
  <div *ngIf="list?.isTypeShop" class="d-flex align-items-center mb-2 w-100 justify-content-between">
    <span>
      <i class="fa-solid fa-eye mr-2"></i>
      {{ viewCount }}
    </span>

    <button class="t-btn" (click)="openDiscuss(list)">
      <i class="fa-solid fa-comments"></i>
      {{ list?.forum?.repliesCount }}
    </button>

    <button class="t-btn" (click)="favoriteProduct(list)">😊😠 {{ list?.foodFavoritesCount }}</button>
  </div>
</ng-template>
<!-- For Product -->

<ng-template #addComment>
  <div class="d-flex p-5 rounded flex-column justify-content-center align-items-center">
    <p class="mb-3" style="font-weight: bold; color: var(--primary)">
      <!-- <i class="fab fa-forumbee"></i>  -->
      Add comment To Forum
    </p>
    <div class="d-flex flex-column w-100 justify-content-center mb-2" style="top: 100%; background-color: var(--white)">
      <textarea rows="3" type="text" class="form-control mb-2" placeholder="Your Comment" [(ngModel)]="repliesHolder"></textarea>
      <button class="btn btn-sm btn-outline-primary" (click)="addPostToForum(forum)"><i class="fa fa-comments"></i> comment</button>
    </div>
  </div>
</ng-template>

<ng-template #discussDialog>
  <div class="d-flex w-100 flex-column h-100 align-items-start p-3">
    <!-- <div class="mt-3 mb-3">
      Dollar Sign Rating({{ list?.dollarSignRatingCount ?? 0}}):
      <div class="dollar-sign-outer" (click)="moduloIncreaseDollarSign()">
        <div class="dollar-sign-inner" [style.width.%]="(list?.dollarSignRating / 3) * 100"></div>
      </div>
    </div> -->

    <div class="d-flex flex-column w-100 align-items-center">
      <div style="color: var(--primary); font-size: 1.3rem" [innerHTML]="productForum?.title"></div>
      <div class="d-flex flex-column m-2 align-items-center w-100" style="text-align: start" *ngIf="productForum?.replies?.length">
        <span class="mb-2 w-100" style="font-size: 1rem; color: var(--primary)">Top Replies:</span>
        <div *ngFor="let reply of productForum?.replies; index as i" class="border w-100" style="color: var(--primary); font-size: 0.9rem">{{ i + 1 + ") " }} <span [innerHTML]="reply.message"></span></div>
      </div>

      <div class="d-flex w-100 justify-content-center mt-2 pb-1" style="background-color: var(--white)">
        <button class="btn btn-sm btn-outline-primary" (click)="openAddCommentModal(forum)"><i class="fa fa-comments"></i> comment</button>
      </div>
    </div>

    <!-- <app-forum-list [forums]="productForums" (reloadForums)="loadForums()" [pageId]="list?.id"
    type="product"></app-forum-list> -->
  </div>
</ng-template>
